import type { SignalExplanation } from "../../lib/queries.js";

/**
 * The numbers behind the sentence, as a definition list.
 *
 * Empty facts render nothing at all: an empty definition list is worse than
 * no list, because it looks like data that failed to load.
 */
export function SignalFacts({ explanation }: { explanation: SignalExplanation }) {
  if (explanation.facts.length === 0) return null;

  return (
    <dl
      className="flex flex-col gap-2 border border-border bg-surface-raised px-4 py-3"
      data-testid="signal-facts"
    >
      {explanation.facts.map((fact) => (
        <div key={fact.label} className="flex justify-between gap-4 text-sm">
          <dt className="text-text-muted">{fact.label}</dt>
          <dd className="tabular-nums text-text">{fact.value}</dd>
        </div>
      ))}
    </dl>
  );
}
